import styled from 'styled-components';

export const HelpButton = styled.button`
  width: ${(props) => props.size || 20}px;
  height: ${(props) => props.size || 20}px;
  padding: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${(props) => (props.theme.name === 'dark' ? '#94a3b8' : '#64748b')};
  transition: color 0.15s ease;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: ${(props) => (props.size && props.size > 20 ? '12px' : '8px')};
  flex-shrink: 0;

  &:hover {
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }

  svg {
    width: ${(props) => (props.size && props.size > 20 ? '20px' : '16px')};
    height: ${(props) => (props.size && props.size > 20 ? '20px' : '16px')};
  }
`;

export const EducationDrawer = styled.div`
  position: fixed;
  top: 0;
  right: ${(props) => (props.isVisible ? '0' : '-480px')};
  width: 480px;
  height: 100vh;
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors.background.primary
      : '#ffffff'};
  box-shadow: ${(props) =>
    props.isVisible ? '-4px 0 24px rgba(0, 0, 0, 0.15)' : 'none'};
  transition: right 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
  z-index: 1001;
  overflow-y: auto;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100vw;
    right: ${(props) => (props.isVisible ? '0' : '-100%')};
  }
`;

export const DrawerOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  pointer-events: ${(props) => (props.isVisible ? 'auto' : 'none')};
  transition: opacity 0.3s ease-in-out;
  z-index: 1000;
`;

export const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  border-bottom: 1px solid
    ${(props) => (props.theme.name === 'dark' ? '#334155' : '#e5e7eb')};
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: ${(props) =>
    props.theme.name === 'dark' ? '#ffffff' : props.theme.colors.blueBlack};
`;

export const DrawerCloseButton = styled.button`
  background: ${(props) =>
    props.theme.name === 'dark' ? 'rgba(255,255,255,0.05)' : 'white'};
  color: ${(props) => (props.theme.name === 'dark' ? '#94A3B8' : '#64748B')};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? 'rgba(255,255,255,0.1)'
        : 'rgba(0,0,0,0.1)'};
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.15s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;

  &:hover {
    color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
    border-color: ${(props) => props.theme?.colors?.primary || '#fa4616'};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const DrawerContent = styled.div`
  padding: 24px;
  color: ${(props) => (props.theme.name === 'dark' ? '#e2e8f0' : '#334155')};
`;
